import { Icons } from '@/components/Shares/Icons';
import { useLingui } from '@lingui/react';
import { ActionIcon, Group, TextInput } from '@mantine/core';
import { SearchFilter } from './SearchFilter';
import classes from './SearchInput.module.css';
import { providers, sorts } from './data';
export const SearchAction: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Group gap={8} justify="center" align="center">
      <TextInput h={46} size="md" radius={5} classNames={classes} style={{
      flexGrow: 1
    }} placeholder={i18n._('search')} rightSection={<ActionIcon size="lg" variant="transparent" c="inherit">
            <Icons className="icon-pr-line-search" fontSize={24} color="inherit" />
          </ActionIcon>} />
      <Group gap={8} wrap="nowrap">
        <SearchFilter w={174} label={i18n._('Provider:')} filters={providers} breakPoint="md">
          <Icons className="icon-pr-line-gaming" fontSize={24} />
        </SearchFilter>
        <SearchFilter w={174} label={i18n._('Sort by:')} filters={sorts} breakPoint="md">
          <Icons className="icon-pr-line-filter" fontSize={24} />
        </SearchFilter>
      </Group>
    </Group>;
};